import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';

const MatureStrictBlockedOverlay: React.FC<HiddenProps> = props => {
  const { t } = useTranslation();

  return (
    <HiddenLayout
      icon={<HiddenIcon size={IconSize.HUGE} />}
      text={t('deviationview.blocked.mature.text')}
      {...props}
    />
  );
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';

export default MatureStrictBlockedOverlay;
